module.exports = __webpack_public_path__ + "static/media/728x90_0003_ru.e222304b.jpeg";